
























































































import {
  Advisor,
  AdvisorNavigation,
  Component,
  Prop,
  Question,
  Vue
} from "@zoovu/runner-browser-api";
import { Getter, State } from "vuex-class";
import { PageView } from "@zoovu/runner-web-design-base";

@Component({
  name: "PageView",
  mixins: [PageView]
})
export default class PageViewExtended extends Vue {
  @Prop()
  question!: Question;

  @Prop()
  navigation!: AdvisorNavigation;

  @State
  advisor!: Advisor;

  @Getter
  shouldSkipCurrentQuestion!: () => boolean;
}
